export default __webpack_public_path__ + "static/1342-8483953355cb5834d965369139dc1531.gif";